export enum TachographWorkingMode {
  RIDE = 'ride',
  OTHER_WORK = 'other-work',
  BREAK = 'break',
  AVAILABILITY = 'availability',
  OFFLINE = 'offline',
}
